import request from '../../utils/requests'

/**
 * Tag: SCITinkerUpRecord
 */

const baseUrl ="/api/SCITinkerUpRecord";



/**
 * 获取调整列表-有效票卡
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区ID Required:true
 *    CourseId Desc:课程ID Required:false
 * }
 */
async function _getTinkerUpList(body) {
  return request(baseUrl+'/getTinkerUpList',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取调整列表-失效票卡
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区ID Required:true
 *    CourseId Desc:课程ID Required:false
 * }
 */
async function _getTinkerUpListForExpired(body) {
  return request(baseUrl+'/getTinkerUpListForExpired',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取调整记录分页
 * @param {*} body
 * {
 *    CourseId Desc:课程ID：必填 Required:false
 *    StudentId Desc:学员Id：必填 Required:false
 *    BranchIdList Desc:校区ID：必填，后台校验权限,校区时填入当前校区ID Required:false
 *    OrgId Desc:后台使用，不用填写 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _paging(body) {
  return request(baseUrl+'/paging',{
    method: 'POST',
    body: body,
  });

}



/**
 * 调整票卡
 * @param {*} body
 * {
 *    BranchId Desc:校区：必传，后台会校验是否有该校区权限 Required:false
 *    StudentId Desc:学员Id:必填 Required:false
 *    CourseId Desc:课程ID Required:false
 *    TinkerUpType Desc:调整类型:必填 枚举：1.余课 2.有效期 3.请假次数 Required:false
 *    StudentCardList Desc:学生票卡调整列表 Required:false
 *    IsSynchroParent Desc:是否同步家长端 Required:false
 *    Remark Desc:备注 Required:false
 * }
 */
async function _tinkerUp(body) {
  return request(baseUrl+'/tinkerUp',{
    method: 'POST',
    body: body,
  });

}



/**
 * 调整过期票卡
 * @param {*} body
 * {
 *    BranchId Desc:校区：必传，后台会校验是否有该校区权限 Required:false
 *    StudentId Desc:学员Id:必填 Required:false
 *    CourseId Desc:课程ID Required:false
 *    TinkerUpType Desc:调整类型:必填 枚举：1.余课 2.有效期 3.请假次数 Required:false
 *    StudentCardList Desc:学生票卡调整列表 Required:false
 *    IsSynchroParent Desc:是否同步家长端 Required:false
 *    Remark Desc:备注 Required:false
 * }
 */
async function _tinkerUpExpiredCard(body) {
  return request(baseUrl+'/tinkerUpExpiredCard',{
    method: 'POST',
    body: body,
  });

}



/**
 * 打印听课证
 * @param {*} body
 * {
 *    StudentId Desc:学员ID:必填 Required:false
 *    CourseId Desc:课程ID:必填 Required:false
 *    BranchId Desc:校区ID:必填 Required:false
 * }
 */
async function _printCourseStudentCard(body) {
  return request(baseUrl+'/printCourseStudentCard',{
    method: 'POST',
    body: body,
  });

}

async function _GetOutDateCardList(body) {
  return request(baseUrl+'/GetOutDateCardList',{
    method: 'POST',
    body: body,
  });

}


export default{
  _getTinkerUpList,
  _getTinkerUpListForExpired,
  _paging,
  _tinkerUp,
  _tinkerUpExpiredCard,
  _printCourseStudentCard,
  _GetOutDateCardList 
}




// WEBPACK FOOTER //
// ./src/services/sCITinkerUpRecord.js